<%= form_with(model: feedback, class: "contents") do |form| %>
  <% if feedback.errors.any? %>
    <div id="error_explanation" class="bg-red-50 text-red-500 px-3 py-2 font-medium rounded-md mt-3">
      <h2><%= pluralize(feedback.errors.count, "error") %> prohibited this feedback from being saved:</h2>

      <ul class="list-disc ml-6">
        <% feedback.errors.each do |error| %>
          <li><%= error.full_message %></li>
        <% end %>
      </ul>
    </div>
  <% end %>

  <div class="my-5">
    <%= form.label :abbr %>
    <%= form.text_field :abbr, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": feedback.errors[:abbr].none?, "border-red-400 focus:outline-red-600": feedback.errors[:abbr].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :value %>
    <%= form.text_field :value, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": feedback.errors[:value].none?, "border-red-400 focus:outline-red-600": feedback.errors[:value].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :order %>
    <%= form.number_field :order, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": feedback.errors[:order].none?, "border-red-400 focus:outline-red-600": feedback.errors[:order].any?}] %>
  </div>

  <div class="inline">
    <%= form.submit class: "w-full sm:w-auto rounded-md px-3.5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white inline-block font-medium cursor-pointer" %>
  </div>
<% end %>
